export type GroupByMethod = "None" | "Array";
